<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل وكيل</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/agentview">وكلاء العقارية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل وكيل</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="loader" class="text-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center align-content-center pt-5">
          <div class="col-12 col-md-8">
            <h5 class="text-brown ms-2">
              <i class="bi bi-pencil-square me-2 text-brown"></i>بيانات الوكيل
            </h5>
            <div class="card">
              <div class="text-center pt-3">
                <errorAlert v-if="agentError" :alertMessage= "message" />
              </div>
              <div v-if="successAgent" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <div class="card-body">
                <div class="row py-2">
                  <div v-if="image" class="col">
                    <div class="text-center">
                      <img :src="BASE_URL+'uploads/'+image" class="rounded-circle w-50" lt="">
                    </div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label class="form-label" for="">الاسم:</label>
                    <div>{{ agentName }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label class="form-label" for="">رقم الجوال:</label>
                    <div>{{ phoneNumber }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label class="phoneNumber" for="">الحاله:</label>
                    <div>{{ (status)? 'نشط' : 'غير نشط' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name:'AgentRead',
  data(){
    return {
      agentId: this.$route.params.id,
      agentError: false,
      message: '',
      agentName: "",
      isLoading: false,
      loader: false,
      status: true,
      successAgent: false,
      phoneNumber: "",
      image: "",
      rows: [],
    }
  },
  computed:{
    ...mapGetters(['BASE_URL'])
  },
  methods:{
    getData(){
      this.agentError = false;
      this.loader = true;
      this.$http.get(`/api/admin/agents/retrieve/${this.agentId}`).then(res => {
        // console.log(res);
        this.loader = false;
        this.image = res.data.agent.avatar;
        this.agentName = res.data.agent.name;
        this.phoneNumber = res.data.agent.mobile;
        this.status = res.data.agent.isActive;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.agentError = true;
        this.loader = false;
        window.scroll(0,0);
      })
    },
  },
  created() {
    this.getData();
  }
}
</script>